const starStore = resolve => require(['@/components/star/star'],resolve);
export default [
	{
		path : 'star/star',
		name : 'starStore',
		meta : {
			title : '明星店铺',
			mainSearchHandle (){

			},
			notNeedGlobalScroll : true,
			searchDisabled : true
		},
		component : starStore
	}
]



// WEBPACK FOOTER //
// ./src/router/star/index.js